import {
  EMPTY_SUBMIT_RESPONSE,
  IComboboxQuestionModelState,
  IComboboxResponseValidation,
  ComboboxQuestionModelTypes
} from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'

const ComboboxQuestionModel: IQuestionModelConstructor<ComboboxQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<ComboboxQuestionModelTypes, IComboboxQuestionModelState>({
    questionType: QuestionType.COMBOBOX,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse
  })
  return model
}

function submitResponse({ response }: IComboboxQuestionModelState) {
  return response
}

function initState(state: IComboboxQuestionModelState): IComboboxQuestionModelState {
  state.response = EMPTY_SUBMIT_RESPONSE
  return state
}

function validateResponse({ response, responseValidation }: IComboboxQuestionModelState): IComboboxResponseValidation {
  if (!response.length)
    return {
      valid: true
    }

  if (responseValidation) return responseValidation

  return {
    valid: false
  }
}

export default ComboboxQuestionModel
